import { render } from "./SaySomethingNiceView.vue?vue&type=template&id=61c17138"
import script from "./SaySomethingNiceView.vue?vue&type=script&lang=js"
export * from "./SaySomethingNiceView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__